import { createBrowserHistory } from "history";

// 共用的 history 實例：讓 React 元件（透過 <Router history={history}>）
// 與 React 之外的程式（如 Apollo client 的全域錯誤處理）能共用同一份導航狀態。
export default createBrowserHistory();
